// tslint:disable max-line-length
import React from 'react';

const CourseLibrary = () => (
  <g>
    <path
      d="M8.6049 13.4761H14.3016V11.9223H8.6049V13.4761ZM8.6049 11.1723H18.6293V9.61847H8.6049V11.1723ZM8.6049 8.86847H18.6293V7.31467H8.6049V8.86847ZM6.65544 19.0478C6.19546 19.0478 5.79659 18.8789 5.45882 18.5412C5.12105 18.2034 4.95217 17.8045 4.95217 17.3445V3.45217C4.95217 2.99054 5.12105 2.59025 5.45882 2.25132C5.79659 1.91239 6.19546 1.74292 6.65544 1.74292H20.5478C21.0095 1.74292 21.4097 1.91239 21.7487 2.25132C22.0876 2.59025 22.2571 2.99054 22.2571 3.45217V17.3445C22.2571 17.8045 22.0876 18.2034 21.7487 18.5412C21.4097 18.8789 21.0095 19.0478 20.5478 19.0478H6.65544ZM6.65544 17.3445H20.5478V3.45217H6.65544V17.3445ZM3.45217 22.257C2.99054 22.257 2.59025 22.0876 2.25132 21.7487C1.91239 21.4097 1.74292 21.0095 1.74292 20.5478V4.95217H3.45217V20.5478H19.0478V22.2571H3.45217V22.257Z"
      fill="#545454"
    />
  </g>
);

export default CourseLibrary;
